import {
  TextField,
  IconButton,
  Typography,
  Box,
  Button,
  Select,
  MenuItem,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormHelperText,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export default function FormDevices({
  devices,
  onChangeDevice,
  setDevices,
  products,
  prices,
  sameErrs,
  addButtonText = 'Add SKU',
  startWithEmptyForm = false
}) {
  const removeDevice = (i) => {
    const copy = [...devices];
    copy.splice(i, 1);
    setDevices(copy);
  };
  return (
    <>
      {(!startWithEmptyForm || devices.length > 0) && (
        <Box display="flex" flexDirection="column">
          <TableContainer sx={{ border: '1px solid #cccccc', borderRadius: 1 }}>
            <Table aria-label="table for SKU" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>SKU</TableCell>
                  <TableCell align="left">Quantity</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {devices.map((device, i) => (
                <TableRow
                  key={`device-${i}`}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row" sx={{ width: '50%' }}>
                    <FormControl fullWidth size="small">
                      <Select
                        value={devices[i].sku}
                        placeholder="Select"
                        onChange={(e) => onChangeDevice(e, i)}
                        name="sku"
                        error={sameErrs[i]}
                      >
                        {Object.keys(products).length &&
                          Object.keys(products).map((sku) => {
                            // remove selected devices from the list, but allow empty slots to show all options
                            const isSelected = devices.some((device, index) => 
                              device.sku === sku && device.sku !== ''
                            );
                            const productName = products[sku]?.name || '';
                            return (
                              <MenuItem value={sku} key={sku} disabled={isSelected}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                  <Typography variant="body2">{sku}</Typography>
                                  {productName && (
                                    <Typography variant="caption" color="text.secondary">
                                      {productName}
                                    </Typography>
                                  )}
                                </Box>
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                    {sameErrs[i] && (
                      <FormHelperText
                        htmlFor="device-select"
                        error={sameErrs[i]}
                      >
                        The SKU already selected
                      </FormHelperText>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    <TextField
                      name="quantity"
                      placeholder={device.label}
                      fullWidth
                      size="small"
                      type="number"
                      value={devices[i].quantity}
                      InputProps={{ inputProps: { min: 1 } }}
                      sx={{
                        width: 'auto',
                        marginBottom: sameErrs[i] ? '20px' : 0,
                      }}
                      onChange={(e) => onChangeDevice(e, i)}
                    />
                  </TableCell>
                  <TableCell>
                    { devices.length > 0 && (
                      <IconButton
                        onClick={() => removeDevice(i)}
                        aria-label={`delete this device`}
                      >
                        <DeleteIcon
                          color="gray.400"
                          sx={{
                            marginBottom: sameErrs[i] ? '20px' : 0,
                            marginTop: '5px',
                          }}
                        />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      )}
      <Box sx={{ mt: 3 }}>
        <Button
          variant="outlined"
          size="small"
          sx={{ float: 'right', width: 200 }}
          onClick={() => {
            const newDevice = { sku: '', quantity: 1 };
            setDevices([...devices, newDevice]);
          }}
        >
          {addButtonText}
        </Button>
      </Box>
    </>
  );
}
